import React from 'react';
import Logo from '../assets/logo/logo.png';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B0F1A]">
      <div className="space-background"></div>

      <div
        className="relative z-10 text-center flex flex-col items-center px-6"
        data-testid="loading-screen"
      >
        {/* Logo */}
        <div className="mb-6">
          <img
            src={Logo}
            alt="Jupiter Cosmic Logo"
            className="
              max-w-[220px] 
              sm:max-w-[300px] 
              md:max-w-[360px]
              w-full
              h-auto
              object-contain
              drop-shadow-[0_0_35px_rgba(0,229,255,0.35)]
              animate-pulse
            "
          />
        </div>

      

        {/* Loading Dots */}
        <div className="flex items-center justify-center space-x-2">
          <div
            className="w-2 h-2 bg-[#00E5FF] rounded-full animate-bounce"
            style={{ animationDelay: '0s' }}
          ></div>
          <div
            className="w-2 h-2 bg-[#00E5FF] rounded-full animate-bounce"
            style={{ animationDelay: '0.2s' }}
          ></div>
          <div
            className="w-2 h-2 bg-[#00E5FF] rounded-full animate-bounce"
            style={{ animationDelay: '0.4s' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;